import { Recreation } from './recreation';
import { Company } from './company';

export type OrderStatus =
  | 'in_progress'
  | 'waiting_for_a_reply_from_partner'
  | 'waiting_for_a_reply_from_facility'
  | 'facility_request_in_progress'
  | 'request_denied'
  | 'waiting_for_an_event_to_take_place'
  | 'unreported_completed'
  | 'final_report_admits_not'
  | 'finished'
  | 'invoice_issued'
  | 'canceled';

export const COMPLETED_ORDER_STATUSES: OrderStatus[] = ['finished', 'invoice_issued', 'canceled'];

export type Order = {
  id: number;
  company: Company;
  recreation: Recreation;
  hostingOfficeName: string;
  zip: string;
  prefecture: string;
  city: string;
  street: string;
  building: string;
  expenses: number;
  transportationExpenses: number;
  additionalFacilityFee: number;
  numberOfPeople: number;
  numberOfFacilities: number;
  price: number;
  couponCode: string;
  materialPrice: number;
  totalPriceForCustomer: number;
  totalFacilityPriceForCustomer: number;
  totalMaterialPriceForCustomer: number;
  status: OrderStatus;
  isEditable: boolean;
  startAt: Date;
  endAt: Date;
  createdAt: Date;
  updatedAt: Date;
};

export type OrderRequest = Omit<
  Order,
  | 'id'
  | 'totalPriceForCustomer'
  | 'totalFacilityPriceForCustomer'
  | 'totalMaterialPriceForCustomer'
  | 'recreation'
>;
